export default {
  path: '/shipowner-business',
  title: '船舶事故管理',
  icon: 'mdi-chart-line-stacked',
  access: '船舶事故管理',

  children: [
    // {
    //   title: '船舶费用统计',
    //   icon: 'mdi-cash-clock',
    //   group: '/ship-cp-total',
    //   children: [
    //     // {
    //     //   path: '/check-cost/check-cost-compare',
    //     //   name: 'check-cost-compare',
    //     //   component: () =>
    //     //     import('@/views/ship-owner/check-cost/check-cost-compare'),
    //     //   meta: {
    //     //     title: '多船检验费对比',
    //     //   },
    //     // },
    //     {
    //       path: '/ship-cp-total/single-ship-cost',
    //       name: 'single-ship-cost',
    //       component: () =>
    //         import('@/views/ship-owner/ship-cost/single-ship-cost'),
    //       meta: {
    //         title: '单船费用汇总',
    //         access: '单船费用汇总',
    //       },
    //     },
    //     // {
    //     //   path: '/ship-cp-total/ship-progress-list',
    //     //   name: 'ship-progress-list',
    //     //   component: () =>
    //     //     import('@/views/ship-owner/ship-progress/ship-progress-list'),
    //     //   meta: {
    //     //     title: '单船费用进度-表',
    //     //     access: '单船费用进度',
    //     //   },
    //     // },
    //     {
    //       path: '/ship-cp-total/ship-progress-chart',
    //       name: 'ship-progress-chart',
    //       component: () =>
    //         import('@/views/ship-owner/ship-progress/ship-progress-chart'),
    //       meta: {
    //         title: '单船费用进度',
    //         access: '单船费用进度',
    //       },
    //     },
    //     {
    //       path: '/ship-cp-total/multi-ship-cost',
    //       name: 'multi-ship-cost',
    //       component: () =>
    //         import('@/views/ship-owner/ship-cost/multi-ship-cost'),
    //       meta: {
    //         title: '多船费用汇总',
    //         access: '多船费用汇总',
    //       },
    //     },
    //     {
    //       path: '/ship-cp-total/histroy-ship-cost-compare',
    //       name: 'histroy-ship-cost-compare',
    //       component: () =>
    //         import('@/views/ship-owner/ship-cost/histroy-ship-cost-compare'),
    //       meta: {
    //         title: '多船历史费用比对',
    //         access: '多船历史费用比对',
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: '船舶价值统计分析',
    //   icon: 'mdi-cube-scan',
    //   group: '/value-of-ship',
    //   children: [
    //     // {
    //     //   path: '/value-of-ship/spare-ships-consume-compare',
    //     //   name: 'spare-ships-consume-compare',
    //     //   component: () =>
    //     //     import('@/views/ship-owner/ship-value/spare-ships-consume-compare'),
    //     //   meta: {
    //     //     title: '多船备件消耗对比',
    //     //   },
    //     // },
    //     {
    //       path: '/value-of-ship/fixed-assets-list',
    //       name: 'fixed-assets-list',
    //       component: () =>
    //         import('@/views/ship-owner/ship-value/fixed-assets-list'),
    //       meta: {
    //         title: '固定资产管理',
    //         access: '固定资产管理',
    //       },
    //     },
    //     {
    //       path: '/value-of-ship/ship-stock-list',
    //       name: 'ship-stock-list',
    //       component: () =>
    //         import('@/views/ship-owner/ship-value/ship-stock-list'),
    //       meta: {
    //         title: '船队库存管理',
    //         access: '船队库存管理',
    //       },
    //     },
    //     {
    //       path: '/value-of-ship/cm-monthly-consume',
    //       name: 'cm-monthly-consume',
    //       component: () =>
    //         import('@/views/ship-owner/ship-value/cm-monthly-consume'),
    //       meta: {
    //         title: '备件物料库存消耗分析',
    //         access: '备件物料库存消耗分析',
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: '船舶业务管理',
    //   icon: 'mdi-stack-exchange',
    //   group: '/owner-ship-manage',
    //   children: [
    //     {
    //       path: '/owner-ship-manage/onwer-ship-list',
    //       name: 'onwer-ship-list',
    //       component: () =>
    //         import('@/views/ship-owner/ship-manage/onwer-ship-list'),
    //       meta: {
    //         title: '船舶状态统计',
    //         access: '船舶状态统计',
    //       },
    //     },
    //     {
    //       path: '/owner-ship-manage/owner-docker-list',
    //       name: 'owner-docker-list',
    //       component: () =>
    //         import('@/views/ship-owner/ship-manage/owner-docker-list'),
    //       meta: {
    //         title: '船队坞修管理',
    //         access: '船队坞修管理',
    //       },
    //     },
    //     {
    //       path: '/owner-ship-manage/supplier-support-total',
    //       name: 'supplier-support-total',
    //       component: () =>
    //         import('@/views/ship-owner/ship-manage/supplier-support-total'),
    //       meta: {
    //         title: '供应商供货统计',
    //         access: '供应商供货统计',
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: '滑油消耗统计',
    //   icon: 'mdi-water-percent',
    //   group: '/total-soil-consume',
    //   children: [
    //     {
    //       path: '/total-soil-consume/soil-annual-consume',
    //       name: 'soil-annual-consume',
    //       component: () =>
    //         import('@/views/ship-owner/soil-consume/soil-annual-consume'),
    //       meta: {
    //         title: '滑油年度消耗',
    //         access: '滑油年度消耗',
    //       },
    //     },
    //     {
    //       path: '/total-soil-consume/soil-monthly-consume',
    //       name: 'soil-monthly-consume',
    //       component: () =>
    //         import('@/views/ship-owner/soil-consume/soil-monthly-consume'),
    //       meta: {
    //         title: '滑油月度消耗',
    //         access: '滑油月度消耗',
    //       },
    //     },
    //     {
    //       path: '/total-soil-consume/expect-soil-list',
    //       name: 'expect-soil-list',
    //       component: () =>
    //         import('@/views/ship-owner/soil-consume/expect-soil-list'),
    //       meta: {
    //         title: '船队滑油费用进度',
    //         access: '船队滑油费用进度',
    //       },
    //     },
    //     {
    //       path: '/total-soil-consume/single-ship-soil-consume',
    //       name: 'single-ship-soil-consume',
    //       component: () =>
    //         import('@/views/ship-owner/soil-consume/single-ship-soil-consume'),
    //       meta: {
    //         title: '单船滑油消耗-图',
    //         access: '单船滑油消耗',
    //       },
    //     },
    //     {
    //       path: '/total-soil-consume/multi-ships-soil-consume',
    //       name: 'multi-ships-soil-consume',
    //       component: () =>
    //         import('@/views/ship-owner/soil-consume/multi-ships-soil-consume'),
    //       meta: {
    //         title: '多船滑油油种比对-图',
    //         access: '多船滑油油种比对',
    //       },
    //     },
    //     {
    //       path: '/total-soil-consume/multi-ships-soil-total',
    //       name: 'multi-ships-soil-total',
    //       component: () =>
    //         import('@/views/ship-owner/soil-consume/multi-ships-soil-total'),
    //       meta: {
    //         title: '多船滑油合计比对-图',
    //         access: '多船滑油油种比对',
    //       },
    //     },
    //   ],
    // },
    // {
    //   title: '船舶租金',
    //   icon: 'mdi-cash-multiple',
    //   group: '/ship-rent',
    //   children: [
    //     {
    //       path: '/ship-rent/rent-contract-list',
    //       name: 'rent-contract-list',
    //       component: () =>
    //         import('@/views/ship-owner/ship-rent/rent-contract-list'),
    //       meta: {
    //         title: '船舶租金协议',
    //         access: '船舶租金协议:列表',
    //       },
    //     },
    //     {
    //       path: '/ship-rent/monthly-rent-list',
    //       name: 'monthly-rent-list',
    //       component: () =>
    //         import('@/views/ship-owner/ship-rent/monthly-rent-list'),
    //       meta: {
    //         title: '船舶月租金管理',
    //         access: '船舶月租金管理:列表',
    //       },
    //     },
    //     {
    //       path: '/ship-rent/monthly-rent-detail/:id',
    //       name: 'monthly-rent-detail',
    //       component: () =>
    //         import('@/views/ship-owner/ship-rent/monthly-rent-detail'),
    //       meta: {
    //         title: '船舶月租金-详情',
    //         notShowInNav: true,
    //         access: '船舶月租金管理:列表',
    //       },
    //     },
    //     {
    //       path: '/ship-rent/year-rent-total',
    //       name: 'year-rent-total',
    //       component: () =>
    //         import('@/views/ship-owner/ship-rent/year-rent-total'),
    //       meta: {
    //         title: '船舶年度租金统计-图',
    //         access: '船舶年度租金统计',
    //       },
    //     },
    //   ],
    // },
  ],
}
